import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";

export const CREATION_FORMATS = [
  {
    id: "knowledge_base",
    sectionId: "create-kb",
    tag: "База знаний",
    icon: <MenuBookOutlinedIcon />,
    label: "06 · Создание",
    title: "База знаний: подсказка всегда под рукой",
    sectionDesc:
      "Инструкции можно забыть — а ответ в боте остаётся в кармане. Сотрудник выбирает вопрос и сразу получает подсказку.",
    desc: "Соберите типовые вопросы команды и ответы — текстом или видео. Инструкцию легко забыть, но подсказка в боте всегда рядом.",
    steps: [
      "Задайте тему базы знаний — HR, продукт, процессы",
      "Добавьте пары «вопрос — ответ» текстом или видео",
      "Упорядочьте вопросы так, как их задаёт команда",
      "Опубликуйте — сотрудник выбирает вопрос в боте и сразу получает ответ",
    ],
    editorLabel: "Редактор базы знаний",
    resultLabel: "Пример в боте",
    panelClass: "landing-band__panel--create-kb",
    bandClass: "landing-band--create-kb",
    editor: (
      <div className="landing-create-mock landing-create-mock--kb">
        <div className="landing-create-mock__field">
          <span>Тема</span>
          <strong>HR и адаптация</strong>
        </div>
        <ul className="landing-create-mock__qa-list">
          <li>Как оформить отпуск?</li>
          <li>Где взять шаблон заявления?</li>
          <li>К кому обратиться по больничному?</li>
        </ul>
        <div className="landing-create-mock__field landing-create-mock__field--answer">
          <span>Ответ</span>
          <strong>Текст или видео-инструкция для сотрудника</strong>
        </div>
      </div>
    ),
    bot: (
      <div className="landing-create-bot">
        <div className="landing-create-bot__bubble">
          <p>Карманная база знаний «HR и адаптация»</p>
          <div className="landing-create-bot__actions landing-create-bot__actions--stack">
            <span>Как оформить отпуск?</span>
            <span>Где взять шаблон?</span>
          </div>
        </div>
        <div className="landing-create-bot__bubble landing-create-bot__bubble--small">
          Отпуск оформляется через HR-портал за 14 дней…
        </div>
      </div>
    ),
  },
  {
    id: "scenario",
    sectionId: "create-scenario",
    tag: "Сценарий",
    icon: <AccountTreeOutlinedIcon />,
    label: "07 · Создание",
    title: "Сценарий: соберите обучение с выбором",
    sectionDesc:
      "Карта сцен, видео и ветки решений — сотрудник проходит программу шаг за шагом в боте.",
    desc: "Соберите программу из видео-сцен и веток решений — сотрудник проходит путь шаг за шагом и принимает решения по ходу.",
    steps: [
      "Выберите тип «Сценарий» при создании проекта",
      "Добавьте сцены, загрузите видео и кнопки выбора",
      "Свяжите сцены в маршрут на карте прохождения",
      "Опубликуйте и отправьте ссылку команде",
    ],
    editorLabel: "Редактор сценария",
    resultLabel: "Пример в боте",
    panelClass: "landing-band__panel--create-scenario",
    bandClass: "landing-band--create-scenario",
    editor: (
      <div className="landing-create-mock landing-create-mock--scenario">
        <div className="landing-create-mock__toolbar">Карта сцен · онбординг</div>
        <div className="landing-create-mock__flow">
          <div className="landing-create-mock__node landing-create-mock__node--start">
            Сцена 1
            <span>Видео + выбор</span>
          </div>
          <div className="landing-create-mock__arrow" />
          <div className="landing-create-mock__branch">
            <div className="landing-create-mock__node">Вариант А</div>
            <div className="landing-create-mock__node">Вариант Б</div>
          </div>
        </div>
      </div>
    ),
    bot: (
      <div className="landing-create-bot">
        <div className="landing-create-bot__bubble">
          <div className="landing-create-bot__poster" />
          <p>Добро пожаловать в программу адаптации</p>
          <div className="landing-create-bot__chip">▶ Видео-сцена</div>
          <div className="landing-create-bot__actions">
            <span>Дальше по регламенту</span>
            <span>Задать вопрос HR</span>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: "trainer",
    sectionId: "create-trainer",
    tag: "Тренажёр",
    icon: <QuizOutlinedIcon />,
    label: "08 · Создание",
    title: "Тренажёр: проверка знаний с обратной связью",
    sectionDesc:
      "Вопросы, мгновенная проверка и результаты — основа для ачивок и мотивации команды.",
    desc: "Добавьте вопросы, отметьте правильные ответы — бот проверит знания, покажет результат и поможет выявить лучших.",
    steps: [
      "Укажите тему тренажёра",
      "Создайте вопросы — текстом или видео",
      "Отметьте верные ответы для каждого вопроса",
      "Опубликуйте — команда проходит тренажёр в боте",
    ],
    editorLabel: "Редактор тренажёра",
    resultLabel: "Пример в боте",
    panelClass: "landing-band__panel--create-trainer",
    bandClass: "landing-band--create-trainer",
    editor: (
      <div className="landing-create-mock landing-create-mock--trainer">
        <div className="landing-create-mock__field">
          <span>Тема</span>
          <strong>Продуктовые знания</strong>
        </div>
        <div className="landing-create-mock__field">
          <span>Вопрос</span>
          <strong>Какой тариф подходит новому клиенту?</strong>
        </div>
        <div className="landing-create-mock__answers">
          <label className="landing-create-mock__answer landing-create-mock__answer--ok">
            ✓ Базовый
          </label>
          <label className="landing-create-mock__answer">Расширенный</label>
          <label className="landing-create-mock__answer">Корпоративный</label>
        </div>
      </div>
    ),
    bot: (
      <div className="landing-create-bot">
        <div className="landing-create-bot__bubble">
          <p>Какой тариф подходит новому клиенту?</p>
          <div className="landing-create-bot__actions">
            <span>Базовый</span>
            <span>Расширенный</span>
          </div>
        </div>
        <div className="landing-create-bot__bubble landing-create-bot__bubble--small">
          ✅ Верно! Отличная работа.
        </div>
      </div>
    ),
  },
];
